<template>
  <div>
    <a :href="url" @click="clickData" target="_blank">
      {{ linkDescription }}
    </a>
  </div>
</template>

<script>
import firebase from "firebase";

export default {
  name: "link",
  props: ["linkDescription", "url"],
  methods: {
    clickData: function() {
      firebase.analytics().logEvent("link");
    },
  },
};
</script>

<style scoped>
div {
  text-align: center;
  margin-top: 120px;
  font-size: 23px;
  font-weight: bold;
}
</style>
